'use client';

import type * as React from 'react';
import { resolvePositioningShorthand, usePositioning } from '@fluentui/react-positioning';
import type { DatePickerProps } from '../DatePicker';

/**
 * Hook used to handle positioning of the popup.
 *
 * @param props - DatePicker props
 * @returns tuple of trigger and popup refs
 * @internal
 */
export function usePopupPositioning(
  props: DatePickerProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
): [triggerRef: React.MutableRefObject<HTMLElement | null>, popupRef: React.MutableRefObject<HTMLDivElement | null>] {
  const { positioning } = props;

  const popupOptions = {
    position: 'below' as const,
    align: 'start' as const,
    ...resolvePositioningShorthand(positioning),
  };

  const { targetRef, containerRef } = usePositioning(popupOptions);

  return [targetRef, containerRef];
}
